import { isPreviewMode } from "./previewUtils";

export function renderPreviewBanner(): void {
    if (!isPreviewMode()) return;

    const banner = document.createElement("div");
    banner.innerText = "⚠️ Diese Landingpage befindet sich im Vorschau-Modus.";
    banner.style.position = "fixed";
    banner.style.top = "0";
    banner.style.left = "0";
    banner.style.right = "0";
    banner.style.backgroundColor = "#f07f5e";
    banner.style.color = "white";
    banner.style.padding = "12px";
    banner.style.textAlign = "center";
    banner.style.zIndex = "99999";
    banner.style.fontWeight = "bold";
    banner.style.fontFamily = "Arial, sans-serif";
    banner.style.boxShadow = "0 2px 8px rgba(0,0,0,0.3)";

    document.body.appendChild(banner);
}
